import { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { roleGuard } from './general/shared/guards/role.guard';
import { aiWorkflowsGuard } from './general/shared/guards/ai-workflows.guard';
import { workflowsGuard } from './general/shared/guards/workflows.guard';
import type { WorkflowsComponent } from './modules/workflows/workflows.component';

export const appRoutes: Route[] = [
	{
		path: 'dashboard',
		loadComponent: () =>
			import('./modules/dashboard/dashboard.component').then((m) => m.DashboardComponent),
		canActivate: [MsalGuard, roleGuard],
	},
	{
		path: 'map-editor',
		loadChildren: () =>
			import('./modules/map-editor/map-editor.module').then((m) => m.MapEditorModule),
		canActivateChild: [MsalGuard, roleGuard],
	},
	{
		path: 'ai-workflows',
		loadComponent: () =>
			import('./modules/ai-workflows/ai-workflows.component').then((m) => m.AiWorkflowsComponent),
		canActivate: [MsalGuard, aiWorkflowsGuard],
		data: { reuse: true },
	},
	{
		path: 'workflows',
		loadComponent: () =>
			import('./modules/workflows/workflows.component').then((m) => m.WorkflowsComponent),
		canActivate: [MsalGuard, workflowsGuard],
		canDeactivate: [(component: WorkflowsComponent) => component.canDeactivate()],
	},
	{
		path: '**',
		redirectTo: 'dashboard',
	},
];
